import { AccordionDetails, AccordionSummary, Accordion as MuiAccordion } from "@mui/material";
import React from "react";
import { AccordionProps } from "../lib/type";
import { cn } from "@/src/shared/utils/mergeTwClasses";

export const Accordion: React.FC<AccordionProps> = ({
    accordionProps,
    summaryProps,
    detailsProps,
    summaryChildren = null,
    detailsChildren = null,
    className,
}) => {
    return (
        <MuiAccordion {...accordionProps} className={cn(className, "shadow-none")}>
            <AccordionSummary {...summaryProps}>
                {summaryChildren}
            </AccordionSummary>
            <AccordionDetails {...detailsProps}>{detailsChildren}</AccordionDetails>
        </MuiAccordion>
    );
};
